import React, { useEffect } from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View, StatusBar, Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StackScreenProps } from '@react-navigation/stack';
import { AuthStackParamList } from '../../types/navigation';
import * as NavigationBar from 'expo-navigation-bar';

type Props = StackScreenProps<AuthStackParamList, 'Landing'>;

const AuthLandingScreen: React.FC<Props> = ({ navigation }) => {
  useEffect(() => {
    if (Platform.OS === 'android') {
      NavigationBar.setButtonStyleAsync('light').catch(() => {});
    }
  }, []);

  return (
    <View style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#000000" translucent={false} />
      <SafeAreaView style={styles.safeArea} edges={['top', 'bottom']}>
        {/* Collage Image */}
        <View style={styles.collageContainer}>
          <Image 
            source={require('../../../assets/welcome.png')} 
            style={styles.collageImage}
            resizeMode="cover"
          />
        </View>

        <View style={styles.bottomSection}>
          {/* Welcome Text */}
          <View style={styles.textContainer}>
            <Text style={styles.welcomeText}>
              One platform, Infinite Business Possibilities
            </Text>
          </View>

          {/* Single Button */}
          <TouchableOpacity
            style={styles.button}
            onPress={() => navigation.navigate('PhoneLogin')}
          >
            <Text style={styles.buttonText}>Get Started</Text>
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000000',
  },
  safeArea: {
    flex: 1,
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 32,
    justifyContent: 'space-between',
    ...(Platform.OS === 'web' ? {
      maxWidth: 480,
      width: '100%',
      marginHorizontal: 'auto' as any,
    } : {}),
  },
  collageContainer: {
    flex: 0.7,
    minHeight: 0,
    width: '100%',
  },
  collageImage: {
    width: '100%',
    height: '100%',
    borderRadius: 24,
  },
  bottomSection: {
    flex: 0.3,
    justifyContent: 'center',
    paddingTop: 32,
    minHeight: 180,
  },
  textContainer: {
    marginBottom: 24,
  },
  welcomeText: {
    fontSize: 32,
    fontWeight: '300',
    color: '#ffffff',
    lineHeight: 42,
    letterSpacing: 0.5,
    flexShrink: 1,
  },
  brandText: {
    fontSize: 32,
    fontWeight: '600',
    color: '#C4963E',
    letterSpacing: 2,
  },
  button: {
    width: '100%',
    height: 56,
    backgroundColor: '#C4963E',
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    color: '#000000',
    fontSize: 18,
    fontWeight: '600',
    letterSpacing: 1,
  },
});

export default AuthLandingScreen;
